import {
  Button, FormControl, Input, Stack, TableCell, TableRow, Paper,
  styled, tableCellClasses, ListItemButton, ListItemText
} from "@mui/material";
import React, { FC, useState } from "react";
import { IPays } from "./Pays";
import SaveIcon from "@mui/icons-material/Save";
import ClearIcon from "@mui/icons-material/Clear";
import { btnStyle } from "../user/Tabs/utilisateur/UtilisateurRow";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import CheckAttr from "../../../../utils/CheckAttr";
import { AxiosInstance } from "axios";
interface paysRowsAtribute {
  row: IPays;
  isDesktopOrLaptop: boolean;
  http: AxiosInstance;
  reloadList: () => void;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 10,
    textAlign: "center",
    color: "#fff",
  },
}));

export const cellStyle: React.CSSProperties = {
  color: "white",
  backgroundColor: "",
  fontSize: 11,
};

export const urlApi = process.env.REACT_APP_BASE_API_URL as string;

const RowPays: FC<paysRowsAtribute> = ({ row, isDesktopOrLaptop, http, reloadList }) => {
  const [modifyCliked, setModifyCliked] = useState(false);
  const [libelleModify, setLibelleModify] = useState<string>(row.libelle);

  const clikValidate = () => {
    if (CheckAttr(libelleModify)) {
      const data = {
        libelle: libelleModify,
      };

      http
        .post(`update/pays/${row.id}`, data)
        .then(() => {
          reloadList();
        }).catch(error => {
          console.log(error);
        })
        .finally(() => {
          setModifyCliked(!modifyCliked);
        });
    }
  };

  const handleChange = (e: any): void => {
    const { name, value } = e.target;
    if (name === "pays") {
      setLibelleModify(value);
    }
  };

  const handleEdit = () => {
    setLibelleModify(row?.libelle);
    setModifyCliked(!modifyCliked);
  };

  return (
    <>
      {isDesktopOrLaptop ? (
        <TableRow>
          <StyledTableCell>
            {!modifyCliked ? (
              row.libelle
            ) : (
              <FormControl variant="outlined">
                <Input
                  sx={{
                    ml: 4,
                    color: "white",
                    fontSize: 12,
                    ":before": { borderBottomColor: "white" },
                    ":after": { borderBottomColor: "#FC8404" },
                  }}
                  name="pays"
                  value={libelleModify}
                  onChange={handleChange}
                  fullWidth
                  autoFocus
                />
              </FormControl>
            )}
          </StyledTableCell>
          <StyledTableCell>
            {modifyCliked === false ? (
              <Button
                size="small"
                variant="outlined"
                sx={btnStyle({
                  bgColor: "#070d23",
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                startIcon={<BorderColorIcon />}
                onClick={() => handleEdit()}
              >
                Modifier
              </Button>
            ) : (
              <Stack
                direction="row"
                spacing={2}
                display="flex"
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  color="warning"
                  size="small"
                  sx={{
                    textTransform: "none",
                  }}
                  startIcon={<SaveIcon />}
                  onClick={() => clikValidate()}
                >
                  Enregistrer
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  size="small"
                  sx={{
                    textTransform: "none",
                  }}
                  startIcon={<ClearIcon />}
                  onClick={() => setModifyCliked(!modifyCliked)}
                >
                  Annuler
                </Button>
              </Stack>
            )}
          </StyledTableCell>
        </TableRow>
      ) : (
        <Paper
          sx={{
            display: 'flex',
            bgcolor: '#fff',
            color: '#080d24',
            mb: 1
          }}
          variant="outlined"
        >
          <ListItemButton
            alignItems="flex-start"
            sx={{
              px: 3,
              "&:hover, &:focus": { "& svg": { opacity: 1 } },
              justifyContent: "space-between",
            }}
          >
            {!modifyCliked ? (
              <ListItemText
                primary={row.libelle}
                primaryTypographyProps={{
                  fontSize: 11,
                  fontWeight: "small",
                  lineHeight: "15px",
                  mt: 1
                }}
                sx={{ my: 0 }}
              />
            ) : (
              <FormControl variant="outlined" sx={{ maxWidth: 120 }}>
                <Input
                  sx={{
                    mt: 0.5,
                    color: "#080d24",
                    fontSize: 10,
                    ":before": { borderBottomColor: "#080d24" },
                    ":after": { borderBottomColor: "#080d24" },
                  }}
                  color="warning"
                  name="pays"
                  value={libelleModify}
                  onChange={handleChange}
                  size="small"
                  autoFocus
                />
              </FormControl>
            )}

            {modifyCliked === false ? (
              <Button
                size="small"
                variant="text"
                sx={btnStyle({
                  bgColor: "#fff",
                  hoverColor: '#EBEAEA',
                  color: "#070d23"
                })}
                onClick={() => handleEdit()}
              >
                <BorderColorIcon fontSize="small" />
              </Button>
            ) : (
              <Stack
                direction="row"
                display="flex"
                justifyContent="center"
              >
                <Button
                  variant="text"
                  color="warning"
                  size="small"
                  onClick={() => clikValidate()}
                >
                  <SaveIcon fontSize="small" />
                </Button>
                <Button
                  variant="text"
                  color="error"
                  size="small"
                  onClick={(e) => setModifyCliked(!modifyCliked)}
                >
                  <ClearIcon fontSize="small" />
                </Button>
              </Stack>
            )}
          </ListItemButton>
        </Paper>
      )}
    </>
  );
};

export default RowPays;
